(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector(".dual-range-slider");
  const handleMin = slider.querySelector(".handle-min");
  const handleMax = slider.querySelector(".handle-max");
  const range = slider.querySelector(".slider-range");
  const minDisplay = slider.querySelector(".min-value");
  const maxDisplay = slider.querySelector(".max-value");
  const collectionHandle = slider.dataset.collection;
  const minin=document.querySelector("#Price-GTE");
  const maxin=document.querySelector("#Price-LTE");
  

  const rangeMax = parseFloat(slider.dataset.rangeMax);
  let minVal = parseFloat(slider.dataset.min);
  let maxVal = parseFloat(slider.dataset.max);
 

  function formatMoney(cents) {
    return   "₹"+((cents / 100)/100).toFixed(2);
  }

  function updateSlider() {



    const minPercent = (minVal / rangeMax) * 100;
    const maxPercent = (maxVal / rangeMax) * 100;

    handleMin.style.left = `${minPercent}%`;
    handleMax.style.left = `${maxPercent}%`;
    range.style.left = `${minPercent}%`;
    range.style.width = `${maxPercent - minPercent}%`;
    minDisplay.textContent = formatMoney(minVal * 100);
    maxDisplay.textContent = formatMoney(maxVal * 100);
    
  }
  

  function setupDrag(handle, isMin) {
    
    
  
    const moveHandler = (clientX) => {
      const rect = slider.getBoundingClientRect();
      let x = clientX - rect.left;
      x = Math.max(0, Math.min(x, rect.width));
      let value = Math.round((x / rect.width) * rangeMax);

      if (isMin) {
        minVal = Math.min(value, maxVal - 1);
      } else {
        maxVal = Math.max(value, minVal + 1);
      }


      updateSlider();
    };

    const onMouseMove = (e) => moveHandler(e.clientX);
    const onTouchMove = (e) => moveHandler(e.touches[0].clientX);

    const endDrag = () => {
     // alert("test");
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", endDrag);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", endDrag);
       minin.value = formatMoney(minVal * 100);
   maxin.value = formatMoney(maxVal * 100);
  minin.dispatchEvent(new Event("input", { bubbles: true }));
maxin.dispatchEvent(new Event("input", { bubbles: true }));

// also trigger CHANGE event (Shopify uses this for auto apply)
minin.dispatchEvent(new Event("change", { bubbles: true }));
maxin.dispatchEvent(new Event("change", { bubbles: true }));
 const minPercent = (minVal / rangeMax) * 100;
    const maxPercent = (maxVal / rangeMax) * 100;

    handleMin.style.left = `${minPercent}%`;
    handleMax.style.left = `${maxPercent}%`;
    console.log('minValend',minVal);
    console.log('maxValend',maxVal);
    
    

   
  
      // Optional: AJAX product filtering
      //fetch(`/collections/all?view=ajax&price_min=${minVal}&price_max=${maxVal}`);
    };

    handle.addEventListener("mousedown", () => {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", endDrag);
    });

    handle.addEventListener("touchstart", (e) => {
      e.preventDefault(); // prevent scrolling while dragging
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", endDrag);
    });
  }

 setupDrag(handleMin, true);
 setupDrag(handleMax, false);

  // Initialize slider
  updateSlider();
  
});
setInterval(displayHello, 100);
function formatMoney1(cents) {
    return  "₹"+((cents / 100)/100).toFixed(2);
  }
function displayHello() {
  const slider = document.querySelector(".dual-range-slider");
 let minVal = parseFloat(slider.dataset.min);
  let maxVal = parseFloat(slider.dataset.max);
  const rangeMax = parseFloat(slider.dataset.rangeMax);
    const handleMin = slider.querySelector(".handle-min");
  const handleMax = slider.querySelector(".handle-max");
  const range = slider.querySelector(".slider-range");
  const minDisplay = slider.querySelector(".min-value");
  const maxDisplay = slider.querySelector(".max-value");
  const minPercent = (minVal / rangeMax) * 100;
    const maxPercent = (maxVal / rangeMax) * 100;
  //console.log(maxin.value);
  handleMin.style.left = `${minPercent}%`;
    handleMax.style.left = `${maxPercent}%`;
    range.style.left = `${minPercent}%`;
    range.style.width = `${maxPercent - minPercent}%`;
    minDisplay.textContent = formatMoney1(minVal * 100);
    maxDisplay.textContent = formatMoney1(maxVal * 100);
  
}
  } catch(e) { console.error(e); }
})();

})();
